import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "chains"
const ChainsIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 21c0-.552.139-1.417.316-1.949l.051-.151c.349-1.049 1.362-1.391 2.287-.766 0 0 2.548 1.866 3.447 1.866H15c1 0 3.39-1.849 3.39-1.849.889-.635 1.894-.299 2.243.749l.051.151A7.38 7.38 0 0 1 21 21c0 .552-.445 1-.993 1H3.993A.994.994 0 0 1 3 21Zm8.3-4a.7.7 0 1 1 1.399-.001A.7.7 0 0 1 11.3 17Zm0-6a.7.7 0 1 1 1.399-.001A.7.7 0 0 1 11.3 11Zm0-6a.7.7 0 1 1 1.399-.001A.7.7 0 0 1 11.3 5ZM7 6.707v2.586l1.294-1.294L7 6.707Zm10 8.573v-2.573l-1.288 1.288L17 15.28Zm0-8.573v2.586l-1.294-1.294L17 6.707ZM7 15.28v-2.573l1.288 1.288L7 15.28Zm4.505.518-1.803-1.803L11.5 12.2a1.305 1.305 0 0 1-.705-.71l-1.8 1.798-1.641-1.642L7 11.293v-.586l.34-.34 1.661-1.661 1.798 1.795c.133-.319.389-.574.71-.705L9.708 7.999l1.797-1.797a1.303 1.303 0 0 1-.707-.707L9.001 7.292 7.354 5.646l-.284-.283a3.012 3.012 0 0 1 2.292-2.294l1.436 1.436c.132-.32.387-.575.707-.707L10.707 3h2.586l-.798.798c.32.132.575.387.707.707l1.437-1.437a2.997 2.997 0 0 1 2.292 2.294l-.285.284-1.647 1.646-1.797-1.797c-.132.32-.387.575-.707.707l1.797 1.797-1.801 1.797c.321.131.577.386.71.705l1.798-1.795 1.661 1.661.34.34v.586l-.354.353-1.641 1.642-1.8-1.798c-.131.32-.385.577-.705.71l1.798 1.795-1.803 1.803c.32.132.575.387.707.707l1.803-1.803 1.655 1.652.273.272a3.012 3.012 0 0 1-2.295 2.305l-1.436-1.436c-.132.32-.387.575-.707.707l.798.798h-2.586l.798-.798a1.303 1.303 0 0 1-.707-.707l-1.437 1.437a2.998 2.998 0 0 1-2.295-2.305l.274-.273 1.655-1.652 1.803 1.803c.132-.32.387-.575.707-.707Z"
          />
        </svg>
      }
    </span>
  )
}
export default ChainsIcon
